@import '../../styles/palette.scss';

.tabs {
  display: block;
}

.tab {
  background: _palette(tabbar-bg-inactive);
  border-radius: 5px 5px 0 0;
  color: _palette(tabbar-fg-inactive);
  cursor: pointer;
  display: inline-block;
  font-size: 16px;
  height: 44px;
  letter-spacing: 0.57px;
  margin-right: 10px;
  margin-top: 5px;
  padding: 10px 55px;
  text-align: center;
  text-decoration: none;

  & * {
    vertical-align: middle;
  }
}

.active {
  background: _palette(tabbar-bg-active);
  color: _palette(tabbar-fg-active);
}

.deactivated {
  background: _palette(tabbar-bg-deactivated);
  color: _palette(tabbar-fg-deactivated);
  cursor: default;
}
